import { Value, Fragment } from '@tempots/dom'
import { Notice } from '@tempots/beatui'
import type { TNode } from '@tempots/dom'

export interface ErrorStateOptions {
  error: Value<string | null>
  title?: TNode
}

/**
 * Reusable error display component using BeatUI Notice
 *
 * @example
 * Ensure(error, (e) =>
 *   ErrorState({ error: e, title: 'Failed to load data' })
 * )
 */
export function ErrorState(options: ErrorStateOptions): TNode {
  const { error, title } = options

  // Extract title string if it's a plain string, otherwise use default
  const titleStr =
    typeof title === 'string' ? title : title ? undefined : undefined

  return Notice(
    {
      variant: 'danger',
      tone: 'subtle',
      title: titleStr,
      icon: 'mdi:alert-circle',
    },
    // If title is a TNode (not string), render it with error
    title && typeof title !== 'string' ? Fragment(title, error) : error
  )
}
